export default `

<ut-academy-quiz-results-container
  ng-if="$ctrl.featureFlags.isOn('UTEST_ACADEMY_REDESIGN_COURSE')"
  [track-id]="$ctrl.courseTrack.id"
  [course-track]="$ctrl.courseTrack"
  [user]="$ctrl.user"
  [use-redesign-catalog]="$ctrl.featureFlags.isOn('UTEST_ACADEMY_REDESIGN_COURSE_CATALOG')">
</ut-academy-quiz-results-container>

<div class="academy" ng-if="!$ctrl.featureFlags.isOn('UTEST_ACADEMY_REDESIGN_COURSE')">
  <div class="container-fluid">
    <div class="academy-header">
      <a ui-sref="academy-home">Academy</a> /
      <span>Quiz - {{$ctrl.courseTrack.name}}</span>
    </div>
    <div class="row">
      <div class="academy-course-track col-md-8">
        <course-track-report-card course-track="$ctrl.courseTrack"></course-track-report-card>
      </div>
      <course-track-nav user="$ctrl.user" course-track="$ctrl.courseTrack"></course-track-nav>
    </div>
  </div>
</div>
`;
